<template>
  <div class="caseItemCom">
    <div class="avatarWrap grey6 f28">
      <img :src="getAvatar" class="l" alt="">{{item.customerName}}
      <div class="zan" :class='{active:item.zan}' @click='zan(item.id)'><span class='zantext'>{{item.zanCount | formatNum}}</span></div>
    </div>
    <div class="pic">
      <div>
        <img :src="item.beforePic | formatImgUrl(300,300,true)" class="l" alt="" @click='preview(0,[item.beforePic,item.afterPic])'>
        <div class="mask">修复前</div>
      </div>
      <div>
        <img :src="item.afterPic | formatImgUrl(300,300,true)" class="l" alt="" @click='preview(1,[item.beforePic,item.afterPic])'>
        <div class="mask">修复后</div>
      </div>
    </div>
    <div class="hGroup" @click='toDetail(item.serviceId,item)'>
      <div class="left">
        <h3 class="f32 bold oneClamp">{{item.symptomName}}</h3>
        <h4 class="f24 grey6 oneClamp">服务项：{{item.serviceName}}</h4>
      </div>
      <div class="f32 bold right">￥{{item.servicePrice}}</div>
    </div>
    <div class="btnGroup" @click='toDetail(item.serviceId,item)'>
      <div class="f28">
        <!-- <span class='time'>{{item.createTimeFormat}}</span> -->
        <span class='privice'>{{item.attentionCount}}</span>
      </div>
      <button class="primary" size="small" @click='toDetail(item.serviceId,item)'>我也要拯</button>
    </div>
    <previewer ref="previewer"></previewer>
  </div>
</template>

<script>
  import caseApi from "@/axios/case";
  import publicObj from '@/assets/js/public';
  import zhugeObj from '@/assets/js/track';
  export default {
    name: 'caseItemCom',
    props: {
      item: {
        type: Object,
        default: () => {}
      },
      types:{
        type: Number,
        default: null
      }
    },
    data () {
      return {}
    },
    watch: {},
    computed: {
      getAvatar () {
        return this.item.headImgUrl || this.DEFAULT_AVATAR
      }
    },
    created () {
    },
    mounted () {
    },
    methods: {
      preview(index,list){
        if(this.types == 10){
          zhugeObj.track({
            title : '推荐案例',
            content : {
              '查看图片' : list[index]
            }
          })
        }else{
          zhugeObj.track({
            title : '全部案例',
            content : {
              '查看图片' : list[index]
            }
          })
        }
        
        this.$refs.previewer.show(index, list, ['修复前','修复后'])
      },
      zan(id){
      
        if(this.types == 10){
          zhugeObj.track({
            title : '推荐案例',
            content : {
              '点赞' : id
            }
          })
        }else{
          zhugeObj.track({
            title : '全部案例',
            content : {
              '点赞' : id
            }
          })
        }
        if(this.item.zan){
          caseApi.unexactZan(id).then((res)=>{
            this.$emit('changeZan',this.item);

          })

        }else{
          caseApi.exactZan(id).then((res)=>{
            this.$emit('changeZan',this.item);

          })

        }   
      },
      toDetail(id,item){
        if(this.types == 10){
          zhugeObj.track({
            title : '推荐案例-我也要拯',
          })
        }else{
          zhugeObj.track({
            title : '全部案例-我也要拯',
          })
        }
        caseApi.curingServiceGoodsId(id).then((res)=>{
          this.$router.push({name:'serviceDetail',query:{serviceId:res}})
        }).catch((res)=>{
          this.$router.push({name:'quick'})
        })
      }
    }

  }
</script>

<style lang="scss" scoped>
.caseItemCom{
  padding: 30px;background: #fff;
  .avatarWrap{
    height: 68px;margin-bottom: 30px;
    line-height: 68px;
    position:relative;
    div{
      position:absolute;
      top:0;
      right:0;
    }
    img{
      width: 66px;height: 66px;
      border-radius: 50%;
      margin-right: 16px;
      border:1px solid $border-color;
    }
  }
  .pic{
    height: 280px;margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
    >div{
      width: 336px;height: 280px;
      border-radius: $base-radius;
      overflow: hidden;
      position: relative;
      img{
        width: 100%;
        height: 100%;
      }
      .mask{
        text-align: center;
        width: 100%;
        height: 42px;
        line-height: 42px;
        color: $white-color;
        background: rgba(0,0,0,.45);
        position: absolute;
        left: 0;
        bottom: 0;
      }
    }
  }
  .hGroup{
    padding: 20px;margin-bottom: 30px;
    border-radius: $base-radius;
    background: #f6f6f6;
    display: flex;
    justify-content: space-between;
    .left{
      width: 500px;
      h3{
        line-height: 44px;
        margin-bottom: 8px;
      }
      h4{
        line-height: 40px;
      }
    }
    .right{
      padding-top: 42px;
      line-height: 44px;
    }
  }
  .zan{
    // padding-right: 48px;
    // padding-left: 20px;
    width: 128px;
    // text-align: center;
    background: url("/images/case/nozan.png") no-repeat right 12px;
    background-size: 100%;
    color:#999;
    font-weight: 500; 
    font-size: 22px;
  }
  .zan.active{
    background-image: url("/images/case/zan.png") ;
    color: #fff;
    font-weight: normal; 
  }
  .zantext{
    width: 90px;
    display: inline-block;
    text-align: center;
    line-height: 50px;
    position: relative;
    top:2px;
  }
  .btnGroup{
    height: 66px;
    line-height: 66px;
    display: flex;
    justify-content: space-between;
    span{
      display: inline-block;
      margin-right: 28px;
      padding-left: 44px;
      background: url("/images/case/preview.png") no-repeat left 48.5%;
      background-size: 34px;
      color:#999;
      font-size: 24px;
    }
    .time{
      background-image: url("/images/case/time.png") ;
      background-size:35px!important; 
      padding-left: 38px!important;
    }
    // .zan{
    //   background-image: url("/images/case/case_item_icon02.png") ;
    // }
    // .zan.active{
    //   background-image: url("/images/case/case_item_icon03.png") ;
    //   color: $brand-color;
    // }
  }
}
</style>
